import { useLanguage } from "../i18n";
import { RoomIcon, SunIcon } from "../icons";
import type { Specimen } from "../types";
import { SpecimenTile } from "./SpecimenTile";

/**
 * Plants are grouped by Location because that is how they are actually tended:
 * one place at a time, not one plant at a time. The band carries the climate,
 * exactly as it does on Today — sun above, shade below.
 */
export function LocationSection({
  location,
  specimens,
  unschedulable,
}: {
  location: Specimen["location"];
  specimens: Specimen[];
  /** Specimens the guide has no interval for where they currently are. */
  unschedulable?: Set<string>;
}) {
  const { t } = useLanguage();
  const outdoor = location.placement === "outdoor";

  return (
    <section className="band" data-placement={location.placement}>
      <div className="band-head">
        {outdoor ? <SunIcon /> : <RoomIcon />}
        <div className="band-names">
          <h2 lang="ar">{location.name.ar}</h2>
          <p className="band-meta">
            {location.name.en} · {outdoor ? t.outdoor : t.indoor}
          </p>
        </div>
        <span className="band-count">{specimens.length}</span>
      </div>

      <ul className="plants">
        {specimens.map((specimen) => (
          <SpecimenTile key={specimen.id} specimen={specimen} unschedulable={unschedulable} />
        ))}
      </ul>
    </section>
  );
}
